import { Badge } from "@/components/ui/badge";

import { choiceChipStyle } from "routes/custom_tables/choiceHelpers";

export default function ChoiceChip({ label, color, children }) {
  return (
    <Badge style={choiceChipStyle(color)}>
      {label}
      {children}
    </Badge>
  );
}
